<template>
  <div class="row">
    <div class="col-md">
      <dl class="dl-horizontal">
        <dt>команда модема</dt>
        <dd><router-link
          class="text-monospace text-muted"
          :to="`/commands/${this.event.modem_command_id}`"
        >{{event.modem_command_id}}</router-link></dd>
        <dt>id</dt>
        <dd><router-link
          class="text-monospace text-muted"
          :to="`/reports/events/${this.event.id}`"
        >{{event.id}}</router-link></dd>
        <template v-for="(value, key) in showData" v-if="value">
          <dt>{{key}}</dt>
          <dd class="text-monospace text-muted">{{value}}</dd>
        </template>
      </dl>
    </div>
    <div class="col-md-8">
      <pre
        v-if="event.params"
        class="event-data-result m-0 p-3"
      >{{ event.params }}</pre>
      <div class="text-muted">
        <div v-if="event.params === null">параметры отсутствуют</div>
      </div>
    </div>
  </div>
</template>

<script>
  import pick from 'lodash/pick'

  export default {
    props: {
      event: {
        type: Object,
      },
    },
    computed: {
      showData () {
        return pick(this.event, [
          'message',
          'date',
          'card_key',
          'sale_type',
        ])
      },
    },
  }
</script>

<style lang="scss">
  @import "boot";
  .event-data-result {
    background-color: $gray-200;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/event-details.vue